import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CalendarDays, Clock, ArrowRight, Book, PenTool, Search, Lightbulb, BookOpen, Filter, SlidersHorizontal } from 'lucide-react';

const Blog = () => {
  const [category, setCategory] = useState('all');

  const blogPosts = [
    {
      id: 1,
      title: "The Rise of Remote Work Opportunities in India's Tech Sector",
      excerpt: "How the pandemic has transformed India's tech landscape, creating more remote work opportunities for professionals across the country.",
      date: "March 20, 2023",
      readTime: "8 min read",
      slug: "remote-work-india-tech",
      image: "https://images.unsplash.com/photo-1586227740560-8cf2732c1531?auto=format&fit=crop&q=80&w=800",
      icon: <PenTool className="h-6 w-6 text-purple-600" />,
      category: "work-culture"
    },
    {
      id: 2,
      title: "Top 10 In-Demand Skills for IT Professionals in India for 2023",
      excerpt: "Discover the most sought-after technical and soft skills that employers are looking for in India's competitive IT job market.",
      date: "March 19, 2023",
      readTime: "10 min read",
      slug: "in-demand-it-skills-india",
      image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?auto=format&fit=crop&q=80&w=800",
      icon: <Search className="h-6 w-6 text-blue-600" />,
      category: "technical-skills"
    },
    {
      id: 3,
      title: "How to Navigate Campus Placements in India's Top Engineering Colleges",
      excerpt: "A comprehensive guide for engineering students preparing for campus recruitment drives at India's premier technical institutions.",
      date: "March 18, 2023",
      readTime: "12 min read",
      slug: "campus-placement-guide",
      image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&q=80&w=800",
      icon: <BookOpen className="h-6 w-6 text-green-600" />,
      category: "career-development"
    },
    {
      id: 4,
      title: "The Growing Importance of Soft Skills in India's Corporate Sector",
      excerpt: "Why technical expertise alone isn't enough, and how developing communication and leadership skills can accelerate your career in India.",
      date: "March 17, 2023",
      readTime: "7 min read",
      slug: "soft-skills-importance",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800",
      icon: <Lightbulb className="h-6 w-6 text-amber-600" />,
      category: "career-development"
    },
    {
      id: 5,
      title: "Mastering the Technical Interview: Tips from India's Top Recruiters",
      excerpt: "Insider advice from hiring managers at leading tech companies on how to excel in technical interviews and coding assessments.",
      date: "March 16, 2023",
      readTime: "9 min read",
      slug: "technical-interview-tips",
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&q=80&w=800",
      icon: <Book className="h-6 w-6 text-purple-600" />,
      category: "technical-skills"
    },
    {
      id: 6,
      title: "Building a Professional Network in India's Tech Community",
      excerpt: "Strategies for expanding your professional connections and leveraging networks to uncover hidden job opportunities in the Indian tech scene.",
      date: "March 15, 2023",
      readTime: "6 min read",
      slug: "professional-networking-india",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80&w=800",
      icon: <PenTool className="h-6 w-6 text-blue-600" />,
      category: "career-development"
    },
    {
      id: 7,
      title: "Navigating Salary Negotiations in India's Tech Industry",
      excerpt: "How to research, prepare, and confidently negotiate your compensation package when receiving job offers from Indian tech companies.",
      date: "March 14, 2023",
      readTime: "8 min read",
      slug: "salary-negotiation-guide",
      image: "https://images.unsplash.com/photo-1605810230434-7631ac76ec81?auto=format&fit=crop&q=80&w=800",
      icon: <Search className="h-6 w-6 text-green-600" />,
      category: "career-development"
    },
    {
      id: 8,
      title: "The Future of AI in India's Job Market: Opportunities and Challenges",
      excerpt: "Exploring how artificial intelligence is reshaping India's employment landscape and creating new career paths for tech professionals.",
      date: "March 13, 2023",
      readTime: "11 min read",
      slug: "ai-future-india-jobs",
      image: "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?auto=format&fit=crop&q=80&w=800",
      icon: <Lightbulb className="h-6 w-6 text-amber-600" />,
      category: "industry-trends"
    },
    {
      id: 9,
      title: "Work-Life Balance: Strategies for Indian Tech Professionals",
      excerpt: "Practical advice for maintaining a healthy equilibrium between your professional responsibilities and personal life in India's demanding tech sector.",
      date: "March 12, 2023",
      readTime: "7 min read",
      slug: "work-life-balance-india",
      image: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?auto=format&fit=crop&q=80&w=800",
      icon: <BookOpen className="h-6 w-6 text-purple-600" />,
      category: "work-culture"
    },
    {
      id: 10,
      title: "Understanding India's Startup Ecosystem: Job Opportunities and Challenges",
      excerpt: "A deep dive into the vibrant startup culture in India and how it's creating unique career opportunities for ambitious professionals.",
      date: "March 11, 2023",
      readTime: "10 min read",
      slug: "india-startup-ecosystem",
      image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&q=80&w=800",
      icon: <Book className="h-6 w-6 text-blue-600" />,
      category: "industry-trends"
    },
    {
      id: 11,
      title: "Cybersecurity Careers in India: Growth Trends and Required Skills",
      excerpt: "An exploration of the rapidly expanding cybersecurity sector in India and the specialized skills needed to succeed in this critical field.",
      date: "March 10, 2023",
      readTime: "9 min read",
      slug: "cybersecurity-careers-india",
      image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&q=80&w=800",
      icon: <Search className="h-6 w-6 text-green-600" />,
      category: "technical-skills"
    },
    {
      id: 12,
      title: "How to Create an Impressive GitHub Portfolio for Indian Employers",
      excerpt: "Tips for showcasing your coding projects and open-source contributions to stand out to potential employers in India's competitive tech market.",
      date: "March 9, 2023",
      readTime: "8 min read",
      slug: "github-portfolio-guide",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=800",
      icon: <PenTool className="h-6 w-6 text-amber-600" />,
      category: "technical-skills"
    }
  ];

  const featuredCategories = [
    { 
      title: "Career Development", 
      icon: <Book className="h-5 w-5 text-purple-600" />,
      bgColor: "bg-purple-50",
      borderColor: "border-purple-100",
      filter: "career-development"
    },
    { 
      title: "Technical Skills", 
      icon: <Search className="h-5 w-5 text-blue-600" />,
      bgColor: "bg-blue-50",
      borderColor: "border-blue-100",
      filter: "technical-skills"
    },
    { 
      title: "Work Culture", 
      icon: <PenTool className="h-5 w-5 text-green-600" />,
      bgColor: "bg-green-50",
      borderColor: "border-green-100",
      filter: "work-culture"
    },
    { 
      title: "Industry Trends", 
      icon: <Lightbulb className="h-5 w-5 text-amber-600" />,
      bgColor: "bg-amber-50",
      borderColor: "border-amber-100",
      filter: "industry-trends"
    }
  ];

  const filteredPosts = category === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === category);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-28 pb-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-apple-text mb-4">
              Career Insights Blog
            </h1>
            <p className="text-xl text-apple-text-secondary max-w-3xl mx-auto">
              Expert advice and industry trends for job seekers in India
            </p>
          </div>

          {/* Featured categories */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
            {featuredCategories.map((cat, index) => (
              <button 
                key={index}
                onClick={() => setCategory(cat.filter)}
                className={`${cat.bgColor} ${cat.borderColor} border rounded-lg p-4 text-center flex flex-col items-center transition-all hover:shadow-md ${cat.filter === category ? 'ring-2 ring-purple-400' : ''}`}
              >
                <div className="mb-2">
                  {cat.icon}
                </div>
                <span className="font-medium">{cat.title}</span>
              </button>
            ))}
          </div>

          {/* Filter controls */}
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-apple-text">Articles</h2>
            <button 
              onClick={() => setCategory('all')}
              className="flex items-center text-sm font-medium text-gray-600 hover:text-purple-600 transition-colors"
            >
              <SlidersHorizontal className="h-4 w-4 mr-2" />
              {category !== 'all' ? 'Clear Filter' : 'All Categories'}
            </button>
          </div>

          {/* Featured post */}
          <div className="mb-12">
            <Link 
              to={`/blog/${filteredPosts[0]?.slug || blogPosts[0].slug}`}
              className="block bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
            >
              <div className="md:flex">
                <div className="md:w-1/2 aspect-video overflow-hidden">
                  <img 
                    src={filteredPosts[0]?.image || blogPosts[0].image} 
                    alt={filteredPosts[0]?.title || blogPosts[0].title} 
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="md:w-1/2 p-8 flex flex-col justify-center">
                  <div className="inline-flex items-center bg-purple-50 text-purple-600 px-3 py-1 rounded-full text-sm font-medium mb-4">
                    {filteredPosts[0]?.icon || blogPosts[0].icon}
                    <span className="ml-2">Featured Article</span>
                  </div>
                  <h2 className="text-2xl font-bold text-apple-text mb-4">{filteredPosts[0]?.title || blogPosts[0].title}</h2>
                  <p className="text-apple-text-secondary mb-6">{filteredPosts[0]?.excerpt || blogPosts[0].excerpt}</p>
                  <div className="flex items-center text-sm text-apple-text-secondary mb-6">
                    <CalendarDays className="h-4 w-4 mr-2" />
                    <span>{filteredPosts[0]?.date || blogPosts[0].date}</span>
                    <span className="mx-2">•</span>
                    <Clock className="h-4 w-4 mr-2" />
                    <span>{filteredPosts[0]?.readTime || blogPosts[0].readTime}</span>
                  </div>
                  <div className="flex items-center text-apple-blue font-medium">
                    Read full article
                    <ArrowRight className="h-4 w-4 ml-2" />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <h2 className="text-2xl font-bold text-apple-text mb-6">More Articles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {filteredPosts.slice(1).map((post) => (
              <Link 
                key={post.id} 
                to={`/blog/${post.slug}`} 
                className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow flex flex-col h-full"
              >
                <div className="aspect-video w-full overflow-hidden relative">
                  <img 
                    src={post.image} 
                    alt={post.title} 
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 bg-white/90 p-2 rounded-full">
                    {post.icon}
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col">
                  <div className="flex items-center text-sm text-apple-text-secondary mb-3">
                    <CalendarDays className="h-4 w-4 mr-2" />
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <Clock className="h-4 w-4 mr-2" />
                    <span>{post.readTime}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-apple-text mb-2">
                    {post.title}
                  </h3>
                  <p className="text-apple-text-secondary mb-4 flex-grow">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center text-apple-blue font-medium mt-auto">
                    Read more
                    <ArrowRight className="h-4 w-4 ml-2" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-8 text-center">
            <h3 className="text-xl font-semibold text-apple-text mb-4">Stay Updated</h3>
            <p className="text-apple-text-secondary mb-6 max-w-2xl mx-auto">
              New articles are published regularly to keep you updated with the latest trends.
              Subscribe to our newsletter to get notified when new content is available.
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="px-4 py-2 rounded-lg border border-gray-300 w-full"
              />
              <button className="bg-apple-blue text-white px-6 py-2 rounded-lg font-medium whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Blog;
